<template>
    <div class="container offset pb-2">
        <form @submit.prevent="sendDevolutiva()">
            <div class="custom-form image-style">
                <i class="fas fa-upload"></i>
            </div>
            
            <div class="form-group">
                <div class="d-flex justify-content-start align-items-center mt-2 row">
                    <div class="col-12">
                        <label class="text-align-left" for="year">Ano:</label>
                        <select
                            v-model="devolutivaYear"
                            class="form-control"
                            id="year"
                            required
                        >
                            <option :value="prevprevYear">{{prevprevYear}}</option>
                            <option :value="prevYear">{{prevYear}}</option>
                            <option :value="actualYear">{{actualYear}}</option>
                            <option :value="nextYear">{{nextYear}}</option>
                            <option :value="nextnextYear">{{nextnextYear}}</option>
                        </select>
                    </div>
                </div>

                <div class="d-flex justify-content-start align-items-center mt-2 row">
                    <div class="col-12">
                        <label class="text-align-left" for="type">Tipo:</label>
                        <select
                            v-model="devolutivaType"
                            class="form-control"
                            id="type"
                            required
                        >
                            <option value="EAPI">EAPI</option>
                            <option value="INAPI">INAPI</option>
                        </select>
                    </div>
                </div>

                <div class="d-flex justify-content-start align-items-center mt-2 row">
                    <div class="col-12">
                        <label class="text-align-left" for="level">Nível:</label>
                        <select
                            v-model="devolutivaLevel"
                            class="form-control"
                            id="level"
                            required
                        >
                            <option :value="6">Estadual</option>
                            <!-- <option :value="5">Regional</option> -->
                            <option :value="4">Municipal</option>      
                        </select>
                    </div>
                </div>

                <div class="d-flex justify-content-start align-items-center mt-2 row" v-if="devolutivaLevel && devolutivaLevel <= 5">
                    <div class="col-12">
                        <label class="text-align-left" for="regional">Regional:</label>
                        <select
                            v-model="regionaisData"
                            class="form-control"
                            id="regional"
                            required
                        >
                            <option
                            v-for="regional in regionais"
                            :key="regional.nome"
                            :value="regional.idRegional"
                            >
                            {{ regional.nome }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="d-flex justify-content-start align-items-center mt-2 row" v-if="devolutivaLevel == 4 && regionaisData">
                    <div class="col-12">
                        <label class="text-align-left" for="municipio">Municipio:</label>
                        <select
                            v-model="municipioData"
                            class="form-control"
                            id="municipio"
                            required
                        >
                            <option
                            v-for="municipio in municipios"
                            :key="municipio.nome"
                            :value="municipio.idMunicipio"
                            >
                            {{ municipio.nome }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="d-flex justify-content-start align-items-center mt-3 row">
                    <div class="col-12">
                        <label class="text-align-left" for="devolutiva">Devolutiva (em pdf):</label>
                        <input type="file" ref="file" @change="uploadFile"
                            id="devolutiva" required accept=".pdf"
                        >
                    </div>
                </div>
            </div>

            <div class="button-div pt-4">
                <Button
                section="orange-outline"
                value="Enviar devolutiva"
                :isOutline="true"
                :hasIcon="true"
                iconName="arrow-up"
                />
            </div>
        </form>
    </div>
</template>
  

<script>
    import Button from "../../components/Button";
    import { Notyf } from "notyf";
    const notyf = new Notyf({
        duration: 5000,
        position: {
            x: "left",
            y: "bottom",
        },
    });

    export default {
        name: "AddDevolutiva",
        props: {
            data: Object,
        },
        components: {
            Button,
        },
        data() {
            return {
                devolutivaYear: "",
                devolutivaType: "",
                devolutivaLevel:"",
                regionaisData:"",
                municipioData:"",
                selectedFile: null,

                prevprevYear: new Date().getFullYear() -2,
                prevYear: new Date().getFullYear() -1,
                actualYear: new Date().getFullYear(),
                nextYear: new Date().getFullYear() + 1,
                nextnextYear: new Date().getFullYear() + 2
            };
        },
        async created() {
            await this.$store.dispatch("setRegionais");
        },
        computed: {

            isFileSent() {
                return this.$store.getters.getIsFileSent;
            },

            /*--------------------------------
            |Retornar as Regionais
            ----------------------------------*/
            regionais() {
                return this.$store.getters.getRegionais;
            },

            /*--------------------------------
            |Retornar os municipios
            ----------------------------------*/
            municipios() {
                return this.$store.getters.getMunicipios;
            },
        },
        watch:{
            /*--------------------------------
            |setar as opçoes de municipios de acordo com a regional selecionada
            ----------------------------------*/
            regionaisData(){
                this.resetMunicipioData();
                const payloadRegMun = {
                    id_regional: this.regionaisData
                };
                if(this.regionaisData){
                    this.$store.dispatch("setRegionalMunicipios", payloadRegMun);
                }
            },
        },
        methods: {
            uploadFile() {
                this.selectedFile = this.$refs.file.files[0];
            },
            resetMunicipioData(){
                this.municipioData = ""
            },
            resetForm(){
                this.devolutivaYear = "";
                this.devolutivaType= "";
                this.devolutivaLevel= "";
                this.regionaisData= "";
                this. municipioData= "";
                this.$refs.file.value = null;
            },
            sucess(){
                this.resetForm();
                this.$emit('emit');
                this.$emit('closeModal');
                notyf.open({
                    type: "success", message: "Devolutiva em pdf adicionada!", 
                });
            },
            error(){
                notyf.open({
                    type: "error", message: "Ops, houve um erro: " + this.$store.getters.getErrorMessage, 
                });
            },
            async sendDevolutiva(){
                if(this.selectedFile.type != 'application/pdf'){
                    notyf.open({
                        type: "error", message: "Formato de arquivo inválido. Formato aceito: pdf." 
                    });
                } else{
                    const formData = new FormData();
                    formData.append('pdf', this.selectedFile);

                    switch (this.devolutivaLevel){
                        case 6:{
                            /*----------------------------- ---
                            |ESTADUAL
                            ----------------------------------*/
                            // Registrando informações do payload
                            const payloadEstadual = {
                                anoDevolutiva: this.devolutivaYear,
                                tipoDevolutiva: this.devolutivaType,
                                idRegional: 1,
                                idMunicipio: null,
                                formData: formData
                            };
                            await this.$store.dispatch("setUploadDevolutiva", payloadEstadual);
                            if(this.isFileSent == true){
                                this.sucess();
                            }
                            else this.error();
                            break;
                        }

                        case 5:{
                            /*----------------------------- ---
                            |REGIONAL
                            ----------------------------------*/
                            // Registrando informações do payload
                            const payloadRegional = {
                                anoDevolutiva: this.devolutivaYear,
                                tipoDevolutiva: this.devolutivaType,
                                idRegional: this.regionaisData,
                                idMunicipio: '',
                                formData: formData
                            };
                            await this.$store.dispatch("setUploadDevolutiva", payloadRegional);
                            if(this.isFileSent == true){
                                this.sucess();
                            }
                            else this.error();
                            break;
                        }

                        case 4:{
                            /*----------------------------- ---
                            |MUNICIPIO
                            ----------------------------------*/
                            // Registrando informações do payload
                            const payloadMunicipio = {
                                anoDevolutiva: this.devolutivaYear,
                                tipoDevolutiva: this.devolutivaType,
                                idRegional: this.regionaisData,
                                idMunicipio: this.municipioData,
                                formData: formData
                            };
                            await this.$store.dispatch("setUploadDevolutiva", payloadMunicipio);
                            if(this.isFileSent == true){
                                this.sucess();
                            }
                            else this.error();
                            break;
                        }
                    }
                }
            }
        },
    };
</script>
  

<style scoped>
    .image-style {
        display: block;
        margin: auto;
        text-align: center;
        font-size: 4.5rem;
    }

    .button-div {
        text-align: right;
        display: flex;
        justify-content: space-around;
    }
</style>